module.exports = __webpack_public_path__ + "img/no_results.c1d67d37.svg";